import { render, staticRenderFns } from "./ekodar.vue?vue&type=template&id=d48d1598&scoped=true&"
import script from "./ekodar.vue?vue&type=script&lang=js&"
export * from "./ekodar.vue?vue&type=script&lang=js&"
import style0 from "./ekodar.vue?vue&type=style&index=0&id=d48d1598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48d1598",
  null
  
)

export default component.exports